import React, { Component } from 'react'
import { APIURL } from '../../../src/hoc/AxiosSetting/axios';
import axios from 'axios';
import moment from 'moment';

import { Formik, Form } from 'formik'

export default class ViewAssign extends Component {
    constructor(props) {
        super(props)
        this.state = {
            //   orgCode : props.match.params.orgcode,
            //   auditplanurl: "",

            reportOfAssign: {
                orgCode: props.match.params.orgcode,
                assignurl: "",

            },
            editStatus: false,
            showMessage: false,

            data: {},
            config: {
                bucketName: process.env.REACT_APP_BUCKET_NAME,
                dirName: process.env.REACT_APP_DIR_NAME /* optional */,
                region: process.env.REACT_APP_REGION,
                accessKeyId: process.env.REACT_APP_ACCESS_ID,
                secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
            },
            buttonStatus: "none",
            downloadbuttonStatus: "none",
            uploadDocumentStatus: "none",
            uploadedDocumentStatus: "none",
            showFile: "Image",
            uploadedProcessUrl: "",
            submitStatus: false,
            isLoading:false
        }
        this.viewAssignUrlInput = React.createRef();
    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.orgcode || 0 };
    }




    componentDidMount() {
      const api=APIURL + '/api/survillance/get/surveillancedata/' + this.state.reportOfAssign.orgCode
        axios.get(api, {headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
         }})
            .then(res => {
                if (res.data.errorCode === 0) {
                    this.setState({ data: res.data.response })
                    this.setState({ editStatus: true })

                }
            })
            .catch(e => {
                console.log("Something went Wrong", e)
                var string = JSON.stringify(e).split("/")[0]
                const regex = /401/g;
                const found = string.match(regex);
    
                console.log("found", found);
                if (found !== null) {
                    window.location.href = "/signin"
                   // alert("if")
                    this.setState({isLoading:true})
                }
            })

    }
    render() {
        if(this.state.isLoading){
            return(<h1>Loading</h1>)
        }
        return (
            <div>
                <Formik
                    enableReinitialize={true}
                // initialValues={initialValues}
                // onSubmit={onSubmit}
                >
                    {formik => <Form>
                        <div className="content-wrapper">
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card-body" style={{ paddingLeft: "50px" }}>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <div className="row">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Client Name</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.orgName}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Surveillance Type</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.surveillanceTypeName}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Certification Audit Done</label>
                                                            <div className="col-sm-3">
                                                                <p>{moment(this.state.data.dateofaudit).format("DD-MMM-YYYY")}</p>
                                                            </div>
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Due Date</label>
                                                            <div className="col-sm-3">
                                                                {this.state.data.duedate === null ? "-"

                                                                    : <p> {moment(this.state.data.duedate).format("DD-MMM-YYYY")}</p>
                                                                }

                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Purpose of Audit </label>
                                                            <div className="col-sm-9">
                                                                <p> {this.state.data.purpose}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Standard Applied</label>
                                                            <div className="col-sm-9">
                                                                <p> {this.state.data.standardapplied}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Scope of Application</label>
                                                            <div className="col-sm-9">
                                                                <p> {this.state.data.scope} </p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <div className="hrstyle">
                                                                <h5>Auditee’s Representative</h5>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Name</label>
                                                            <div className="col-sm-3">
                                                                <p> {this.state.data.auditrepresentative}</p>
                                                            </div>
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Contact No</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.contactno}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <div className="hrstyle">
                                                                <h5>Team Leader</h5>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Team Leader/ Lead Auditor</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.teamleaderName}</p>
                                                            </div>
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Contact No</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.contactno1}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <div className="hrstyle">
                                                                <h5>Auditor (If Any)</h5>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Name</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.auditorOneName === null ? "-" : this.state.data.auditorOneName} </p>
                                                            </div>
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Contact No</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.contactno2 === null ? "-" : this.state.data.contactno2}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <div className="hrstyle">
                                                                <h5>Technical Expert (If Any)</h5>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Technical Expert Name</label>
                                                            <div className="col-sm-3">
                                                                <p> {this.state.data.technicalExpertName === "" ? '-' : this.state.data.technicalExpertName}</p>
                                                            </div>
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Contact No</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.contactno3 === null ? '-' : this.state.data.contactno3}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date</label>
                                                            <div className="col-sm-3">
                                                                {this.state.data.datesur === null ? "-"

                                                                    : <p> {moment(this.state.data.datesur).format('DD-MMM-YYYY')}</p>

                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                     
                    </Form>
                    }
                </Formik>
            </div>
        )
    }
}
